<template>
  <hic-list-page title="班次系列" :entities="entities" :condition="condition" @ok="page" @load="page" :loading="loading" ref="listPage">
    <template slot="buttons">
      <el-button type="primary" @click="create" size="small">
        <i class="el-icon-plus"></i>
        新建班次系列
      </el-button>
    </template>
    
    <el-table-column label="操作" width="120" align="center" fixed="left">
      <template slot-scope="scope">
        <el-button type="primary" icon="el-icon-edit" circle plain size="mini" @click="edit(scope.row)" />
        <hic-regret-button type="danger" icon="el-icon-delete" circle plain @click="del(scope.row)" :seconds="3" size="mini" class="left-pad" />
      </template>
    </el-table-column>
    
    <el-table-column label="系列名称" prop="name" min-width="150" align="center"></el-table-column>
    
    <el-table-column label="适用医护类型" prop="staffTypeCode" min-width="120" align="center">
      <template slot-scope="{ row }">
        {{ row.staffTypeCode | dictText('TitleType') }}
      </template>
    </el-table-column>
    
    <el-table-column label="包含班次" prop="items" min-width="200" align="center">
      <template slot-scope="{ row }">
        <span v-if="row.items && row.items.length > 0">
          {{ row.items.length }} 个 ({{ getShiftNames(row.items) }})
        </span>
        <span v-else>0 个</span>
      </template>
    </el-table-column>
    
    <shift-type-series-edit :visible.sync="showEditor" :entity="currentEntity" @ok="page" />
  </hic-list-page>
</template>

<script>
import api from '@/common/api'
import { mapGetters } from "sw-hic";

export default {
  name: 'shiftTypeSeriesView',
  components: {
    'shift-type-series-edit': () => import('./edit')
  },
  data() {
    return {
      loading: false,
      showEditor: false,
      entities: { items: [], total: 0, index: 1 },
      condition: {
        pageIndexOnView: 1,
        pageSize: 20
      },
      currentEntity: {},
      staffTypes: [],
      shiftTypes: []
    }
  },
  computed: {
    ...mapGetters(["permission", "dict", "user"]),
    
  },
  mounted() {
    this.loadMeta()
  },
  methods: {
    loadMeta() {
      this.staffTypes = this.dict.TitleType
      api.ShiftType.query({ pageSize: 999 }).then(res => {
        this.shiftTypes = res.items
      })
    },
    getShiftNames(items) {
      if (!items || !items.length) return ''
      return items.map(item => {
        const shift = this.shiftTypes.find(s => s.id === item.shiftTypeId)
        return shift ? shift.name : '未知'
      }).join(', ')
    },
    page() {
      this.loading = true
      api.ShiftTypeSeries.query(this.condition).then(res => {
        this.entities = res
      }).catch(err => {
        this.$message.error('加载失败: ' + err)
      }).finally(() => {
        this.loading = false
      })
    },
    create() {
      this.currentEntity = {
        id: null,
        name: '',
        staffTypeCode: null,
        items: []
      }
      this.showEditor = true
    },
    edit(row) {
      this.currentEntity = this.$utils.Obj.clone(row)
      this.showEditor = true
    },
    del(row) {
      api.ShiftTypeSeries.del(row.id).then(() => {
        this.$message.success('删除成功')
        this.page()
      }).catch(err => {
        this.$message.error('删除失败: ' + err)
      })
    }
  }
}
</script>
